export const SUPPLIERS_QUERY_KEYS = {
  all: ["suppliers"] as const,
  list: (params: Record<string, unknown>) => [...SUPPLIERS_QUERY_KEYS.all, params] as const,
  detail: (id: string, fields?: string) => [...SUPPLIERS_QUERY_KEYS.all, id, fields] as const,
} as const;
